import type { SanityImage } from '@repo/models/gatsby-graphql-types';

interface CreateOpenGraphTagsForSupportSiteProps {
  title?: string;
  url?: string;
  image?: SanityImage | string;
  description?: string;
}

const createOpenGraphTagsForSupportSite = (
  meta: CreateOpenGraphTagsForSupportSiteProps
) => {
  const openGraphImageUrl = image => {
    if (typeof image === 'string') return image;

    // if sanity image, let's crop it
    let url = `${image?.asset?.url}?w=1200&h=630`;
    if (image?.hotspot) {
      // if we've got a hotspot, use it
      const { x } = image.hotspot;
      const { y } = image.hotspot;
      url += `&fit=crop&crop=focalpoint&fp-x=${x}&fp-y=${y}`;
    }

    return url;
  };

  const metaTags = [
    /*
     * OpenGraph
     */
    {
      property: 'og:image',
      content: openGraphImageUrl(meta.image),
    },
    {
      property: 'og:url',
      content: meta.url,
    },

    {
      property: 'og:title',
      content: meta.title,
    },
    {
      property: 'og:description',
      content: meta.description,
    },
  ];

  return metaTags;
};

export default createOpenGraphTagsForSupportSite;
